<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('profile.sectionparameter.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.bracket"
            :error-messages="bracketErrors"
            :label="$t('profile.sectionparameter.bracket')"
            required
            @input="$v.item.bracket.$touch()"
            @blur="$v.item.bracket.$touch()"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="softwareVersionSelectItems"
            v-model="item.softwareVersion"
            :items="softwareVersionSelectItems"
            :error-messages="softwareVersionErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.sectionparameter.software')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

        <v-col cols="12"></v-col>
      </v-row>

    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'SectionParameterForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.softwareVersionGetSelectItems();
  },
  data() {
    return {
        name: null,
        bracket: null,
        softwareVersion: null,
    };
  },
  computed: {
    isLoading() {
      return (this.isLoading_softwareversion
       );
    },
      ...mapFields('softwareversion', {
        softwareVersionSelectItems: 'selectItems',
        isLoading_softwareversion : 'isLoading'
      }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    bracketErrors() {
      const errors = [];

      if (!this.$v.item.bracket.$dirty) return errors;

      has(this.violations, 'bracket') && errors.push(this.violations.bracket);

      !this.$v.item.bracket.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    softwareVersionErrors() {
      const errors = [];

      if (!this.$v.item.softwareVersion.$dirty) return errors;

      has(this.violations, 'softwareVersion') && errors.push(this.violations.softwareVersion);


      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        softwareVersionGetSelectItems: 'softwareversion/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      name: {
        required,
      },
      bracket: {
        required,
      },
      softwareVersion: {
      },
    }
  }
};
</script>
